import './Select.css';

import PropTypes from 'prop-types';

const Select = ({ children, type, className }) => {
  Select.propTypes = {
    children: PropTypes.any,
    type: PropTypes.string,
    className: PropTypes.string
  };

  return (
    <div
      className={className ? `${className} select-container` : 'select-container'}
      style={{ width: type === 'fill' ? '100%' : type }}>
      {children}
    </div>
  );
};

export default Select;
